var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{attrs:{"cities":JSON.parse(_vm.cities),"params":JSON.parse(_vm.params)}})
}
var staticRenderFns = []

export { render, staticRenderFns }